function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-check"
}, /*#__PURE__*/React.createElement("rect", {
  width: 64,
  height: 64
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "check",
  clipPath: "url(#clip-check)"
}, /*#__PURE__*/React.createElement("g", {
  id: "checkmark-circle-outline",
  transform: "translate(-2 -2)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path",
  d: "M27.319,32.064a2.844,2.844,0,0,0-4.042,0,2.891,2.891,0,0,0,0,4.069l8.539,8.6a2.75,2.75,0,0,0,4.07-.143L55.81,21.663a2.879,2.879,0,0,0-.336-3.948,2.833,2.833,0,0,0-3.933.166l-17.7,20.631Z",
  fill: "#2e5bff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path-2",
  "data-name": "Path",
  d: "M59.731,30.838A2.826,2.826,0,0,0,56.9,33.66,22.639,22.639,0,1,1,34.267,11.084a24.935,24.935,0,0,1,5.376.621,2.823,2.823,0,1,0,1.33-5.475,29.9,29.9,0,0,0-6.706-.79A28.22,28.22,0,1,0,62.56,33.66,2.826,2.826,0,0,0,59.731,30.838Z",
  fill: "#2e5bff"
})));

var SvgCheck = function SvgCheck(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCheck, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/check.c694c5bc.svg";
export { ForwardRef as ReactComponent };